import { render, staticRenderFns } from "./BbsSelector.vue?vue&type=template&id=0043cf7a&"
import script from "./BbsSelector.vue?vue&type=script&lang=js&"
export * from "./BbsSelector.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports